import React, { useState, useEffect } from 'react';
import articles from './articleData';
import ArticleSquares from './ArticleSquares';
import { Link } from 'react-router-dom';

import './styles/home.css';

const ArticleSlider = () => {
    const mobileWidth = 768;
    const tabletWidth = 992;

    const [isTablet, setIsTablet] = useState(window.innerWidth <= tabletWidth && window.innerWidth > mobileWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= mobileWidth);

    useEffect(() => {
        const handleResize = () => {
            setIsTablet(window.innerWidth <= tabletWidth && window.innerWidth > mobileWidth);
            setIsMobile(window.innerWidth <= mobileWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const numberSlides = isMobile ? 1 : isTablet ? 2 : 3;

    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeArticles, setActiveArticles] = useState(articles.slice(0, numberSlides));

    useEffect(() => {
        setActiveArticles(articles.slice(currentIndex, currentIndex + numberSlides));
    }, [currentIndex, numberSlides]);

    const nextBtnClick = () => {
        const newIndex = (currentIndex + numberSlides) % articles.length;
        setCurrentIndex(newIndex);
    };

    const prevBtnClick = () => {
        const newIndex = (currentIndex - numberSlides + articles.length) % articles.length;
        setCurrentIndex(newIndex);
    };

    return (
        <div id="article-slider-main">

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '2em' }}>
                <img className="article-icon" src={process.env.PUBLIC_URL + 'images/article-gold.png'}></img>
                <h2 className='articles-header'>ARTICLES</h2>
            </div>
            <div className='article-header-line'></div>
            <div id="slider-grid">
                {activeArticles.map((article) => (

                    <ArticleSquares key={article.id} article={article} />


                ))}
            </div>
            <div id="slider-control">
                <div id='sc-15'>
                    <Link style={{ textDecoration: 'none' }} to="/articlespage">
                        <p>15 Articles total <span id='ar'>&#x2B62;</span></p>
                    </Link>

                </div>

                <div id="slider-control-buttons">

                    <div onClick={prevBtnClick} className='art-sld-btn'>
                        <svg className='arrow-prev-intro arrow-intro' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                            <path
                                className='prev-intro svg-btn-intro'
                                d="M217.4,165.87a7.76,7.76,0,0,0,0,12.12l52,41.61,38.68,30.94a12.87,12.87,0,0,0,20.91-10h0a12.88,12.88,0,0,0-4.83-10.05L310.62,219.6,251,171.93l59.6-47.65,13.57-10.85A12.89,12.89,0,0,0,329,103.38h0a12.87,12.87,0,0,0-20.91-10l-38.68,31Z"
                                transform="translate(-214.49 -90.49)"
                            />
                        </svg>
                    </div>

                    <div onClick={nextBtnClick} className='art-sld-btn'>
                        <svg className='arrow-next-intro arrow-intro' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                            <path
                                className='next-intro svg-btn-intro'
                                d="M326.1,165.87a7.75,7.75,0,0,1,0,12.12l-52,41.61-38.69,30.94a12.86,12.86,0,0,1-20.9-10h0a12.88,12.88,0,0,1,4.83-10.05l13.57-10.85,59.6-47.67-59.6-47.65-13.57-10.85a12.89,12.89,0,0,1-4.83-10.05h0a12.86,12.86,0,0,1,20.9-10l38.69,31Z"
                                transform="translate(-214.49 -90.49)"
                            />
                        </svg>
                    </div>

                </div>


            </div>
        </div>
    );
};

export default ArticleSlider;




